module.exports = __webpack_public_path__ + "static/media/tip_efirma.d6eb0aac.jpg";